"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TrainingStatusCode;
(function (TrainingStatusCode) {
    TrainingStatusCode["Queued"] = "queued";
    TrainingStatusCode["Running"] = "running";
    TrainingStatusCode["Completed"] = "completed";
    TrainingStatusCode["Failed"] = "failed";
})(TrainingStatusCode = exports.TrainingStatusCode || (exports.TrainingStatusCode = {}));
//# sourceMappingURL=App.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/models/dist/App.js
// module id = 732
// module chunks = 0